import { render } from "./template.vue?vue&type=template&id=3b451c32&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=3b451c32&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b451c32"]])

export default __exports__